<template>
    <div
        class="vhp-simple-card"
        :class="!content.image ? 'no-image' : ''"
        @click="onClickCard(content)"
    >
        <div class="content">
            <div class="background" v-if="content.image" :style="'background-image:url(' + content.image + ')'"/>

            <h3>
                {{content.title}}
                
                <!-- <div class="button next" @click="next()">
                <span/>
                <span/>
                </div> -->
            </h3>

            <div class="tag-wrap">
                <span v-for="tag in content.hashTags" :key="'tag-' + content.id + tag" class="tag">
                #{{tag}}
                </span>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    props:{
        content:{
            type: Object,
            default: () => {
                return null
            }
        },
        baseUrl:{
            type:String,
            default: '/'
        },
        listUrl:{
            type: String,
            default:'/'
        }
    },
    data() {
        return {

        }
    },
    mounted() {

    },
    methods:{
        onClickCard(content) {
            if(content.isExternalLink) {
                window.open(content.externalUrl)
            } else {
                this.$router.push(this.baseUrl + '?id=' + content.id + '&list=' + this.listUrl)
            }
        },

        getCategoryImage(category) {
            return '@/assets/image/category/' + category.toLowerCase() + '.svg'
        },

        replaceImage(e) {
            const canvas = document.createElement('canvas')
            const ctx = canvas.getContext('2d')
            const container = document.getElementsByClassName('vhp-card-image')[0]

            canvas.width = container.clientWidth
            canvas.height = 280

            ctx.font = '32px bold Apple SD Gothic Neo, Pretendard-Regular, NotoSansKR, sans-serif '
            ctx.textBaseline = 'middle'
            ctx.textAlign = 'center'
            ctx.fillStyle = "#C4182890";
            ctx.fillRect(0, 0, container.clientWidth, 280);

            ctx.fillStyle = "#C4182830";
            ctx.beginPath();
            ctx.moveTo(container.clientWidth * 0.6, 0);
            ctx.lineTo(container.clientWidth, 0);
            ctx.lineTo(container.clientWidth, 200);
            ctx.fill();
            
            ctx.fillStyle = "#C4182860";
            ctx.beginPath();
            ctx.moveTo(container.clientWidth * 0.6, 280);
            ctx.lineTo(container.clientWidth, 280);
            ctx.lineTo(container.clientWidth, 140);
            ctx.fill();

            ctx.fillStyle = "#FFFFFF";
            ctx.fillText(this.content.title, container.clientWidth / 2, 140)
            let src = canvas.toDataURL('image/png', 1.0)
            e.target.src = src
        }
    }

}
</script>

<style lang="scss" scoped src="./vhpSimpleCard.scss"></style>